import React from "react";
import { IconButton, IconButtonClassKey, IconButtonProps } from "@material-ui/core";
import clsx from "clsx";
import { getTheme, useOtherStyles } from "./utils";
import getTestIDs from "lib/utils/getTestIDs";

export const testIDs = getTestIDs();
export interface DefaultButtonProps extends IconButtonProps {
  animation?: "" | "pulse" | "spin";
  buttonType: "primary" | "secondary" | "danger" | "radial";
  classes?: Partial<Record<IconButtonClassKey, string>>;
  disabled?: boolean;
  label?: string;
  onClick: () => void;
  theme?: "light" | "dark";
  width?: string;
}

const DefaultButton: React.FC<DefaultButtonProps> = (props) => {
  const {
    label = "",
    buttonType = "",
    onClick,
    disabled = false,
    animation = "",
    theme = "light",
    classes,
    width = "standard",
    style,
  } = props;

  const otherClasses = useOtherStyles();
  const color = buttonType === "primary" || buttonType === "secondary" ? buttonType : "default";
  const layoutWrapper =  label ? otherClasses.combinedWrapper : otherClasses.wrapper;
  const computedWidth = width === "standard" && !label ? "40px" : width === "standard" ? "280px" : width;
  const dangerStyles = buttonType === "danger" ? otherClasses.danger : "";
  const radialStyles = buttonType === "radial" ? otherClasses.radial : "";
  const pulse = animation === "pulse" && true;
  const spin = animation === "spin" && true;
  const darkTheme = getTheme(theme, buttonType, otherClasses);

  return (
    <IconButton
      data-testid={testIDs.DefaultButton}
      className={clsx(radialStyles, dangerStyles, darkTheme)}
      style={{ width: computedWidth, ...style }}
      onClick={onClick}
      disabled={disabled}
      classes={classes}
      color={color}
    >
      <div className={layoutWrapper}>
        {label && <span className={otherClasses.label}>{label}</span>}
      </div>
    </IconButton>
  );
};

export default DefaultButton;
